import * as React from 'react';
import { format } from 'date-fns';
import { CategoryInput } from './CategoryInput';
import { formatMoney } from '../../../../utils/formatters';
import { MerchantPopup } from './MerchantPopup';
import { MoreInfoIcon } from '../../../Icon';
import { PaymentDataPopup } from './PaymentDataPopup';
import { Table } from '../../../Table';


var PaymentDataIcon = function (_a) {
    var paymentData = _a.paymentData, amount = _a.amount;
    return (React.createElement(PaymentDataPopup, { trigger: React.createElement(MoreInfoIcon, null), paymentData: paymentData, amount: amount }));
};
var Transactions = function (_a) {
    var transactions = _a.transactions, categories = _a.categories, onUpdateTransactionCategory = _a.onUpdateTransactionCategory;
    var transactionsRows = transactions.map(function (transaction) {
        var date = format(new Date(transaction.date), 'dd/MM/yyyy');
        var description = (React.createElement("div", { className: 'description-cell' },
            transaction.merchant ? (React.createElement(MerchantPopup, { merchant: transaction.merchant, description: transaction.description })) : (React.createElement("span", null, transaction.description)),
            transaction.paymentData && (React.createElement(PaymentDataIcon, { paymentData: transaction.paymentData, amount: formatMoney(transaction.amount, transaction.currencyCode) }))));
        var category = (React.createElement(CategoryInput, { category: transaction.category || '-', categories: categories, onUpdateTransactionCategory: onUpdateTransactionCategory, transactionId: transaction.id }));
        var amount = formatMoney(transaction.amount, transaction.currencyCode);
        return [date, description, category, amount];
    });
    return (React.createElement(Table, { className: 'Transactions pluggy', headers: ['Data', 'Descrição', 'Categoria', 'Valor'], rows: transactionsRows }));
};
export default React.memo(Transactions);
